import { AutogenModelSendRateConfirmation, AutogenRowSendRateConfirmation } from "./autogen/AutogenModelSendRateConfirmation";

export class ModelSendRateConfirmation extends AutogenModelSendRateConfirmation<RowSendRateConfirmation> {
    constructor() {
        super(RowSendRateConfirmation);
    }
}

export class RowSendRateConfirmation extends AutogenRowSendRateConfirmation {
}